/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import { SET_ACTIVE_COMPONENT } from './interactivelayer.types';
import { setActiveInteractiveComponentAction } from './interactivelayer.actions';

const initialState: {
    activeComponent: string;
} = {
    activeComponent: '',
};

const interactiveLayerReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_ACTIVE_COMPONENT: {
            return {
                ...state,
                activeComponent: payload.activeComponent,
            };
        }
        default:
            return state;
    }
};

export const setActiveInteractiveComponent = (activeComponent: string) => (dispatch: Function) => {
    dispatch(setActiveInteractiveComponentAction(activeComponent));
};

export const clearActiveInteractiveComponent = () => (dispatch: Function) => {
    dispatch(setActiveInteractiveComponentAction(''));
};

export default interactiveLayerReducer;
